export const manifest = {
  screens: {
    scr_ytqvtq: { name: "Join the waitlist", route: "/", state: {"joined":false}, position: {"x":160,"y":220} },
    scr_xed7qp: { name: "You&apos;re in line", route: "/", state: {"joined":true}, position: {"x":1560,"y":220} },
  },
  sections: {
    sec_v17su0: { name: "Waitlist signup flow", x: 0, y: 0, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_v17su0", children: [
      { kind: "screen", id: "scr_ytqvtq" },
      { kind: "screen", id: "scr_xed7qp" },
    ] },
  ],
}
